<template>
  <div class="ma-3">
    <form>
      <h1 class="title font-weight-regular">
        {{ formName }} - {{ form.prisoner_full.string_details }}
      </h1>

      <v-row>
        <v-col
          v-for="item in items"
          :key="item.name"
          cols="6"
        >
          <v-card>
            <v-card-title>
              {{ item.fullName }} &nbsp;
              <v-icon @click="showDialog(item.name)">
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-for="textfield in item.textfields"
                :key="textfield.name"
                v-model="form[textfield.name]"
                required
                outlined
                :label="textfield.fullName"
              />

              <v-radio-group
                v-if="item.radios"
                v-model="form[item.name]"
                :mandatory="true"
              >
                <v-radio
                  v-for="radio in item.radios"
                  :key="radio.label"
                  :color="radio.color"
                  :label="radio.label"
                  :value="radio.value"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-card-title />
            <v-card-text>
              <v-file-input
                v-model="dotaznik_file"
                accept=".pdf"
                label="Dotazník CMRS"
              />
              <pdf
                v-if="form.dotaznik"
                style="width:30%"
                :src="form.dotaznik"
              />
              <v-btn
                v-if="form.dotaznik"
                color="primary"
                @click="downloadItem(form.dotaznik)"
              >
                Stiahnuť
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="error"
          @click="closeItem()"
        >
          Uzatvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-text
            v-for="(item, index) in dialog_item.texty"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import pdf from "vue-pdf";
import axios from "axios";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
Vue.use(VeeValidate);
Validator.localize("sk", sk);


export default {
  name: "GeneralFormComponent",

  $_veeValidate: {
    validator: "new"
  },

  components: {
    pdf
  },

  props: {
    itemId: { type: Number, required: true },
    formName: { type: String, required: true },
    items: { type: Array, required: true },
    dialogs: { type: Object, required: true },
    getItemFunction: { type: Function, required: true },
    updateItemFunction: { type: Function, required: true },
  },


  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      texty: []
    },

    form: {
      prisoner_full: {
        string_details: ""
      }
    },

    dotaznik_file: null,
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    showDialog(x) {
      this.dialog = true;
      this.dialog_item.nazov = this.dialogs[x].nazov;
      this.dialog_item.texty = this.dialogs[x].texts;
    },
    getItem() {
      this.getItemFunction(this.itemId)
        .then(response => {
          this.form = response;
        });
    },

    updateItem() {
      let formData = new FormData();

      for (var key in this.form) {
        if (key == "dotaznik") continue;

        if (this.form[key] != null) formData.set(key, this.form[key]);
      }

      // TODO add delete of file
      // if (this.form.dotaznik_file == null) formData.append("dotaznik", "");

      if (this.dotaznik_file instanceof File)
        formData.append("dotaznik", this.dotaznik_file);

      this.updateItemFunction(formData, this.itemId)
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť tento formulár? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;
            this.updateItem();
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },

    downloadItem(url) {
      var oldThis = this;
      axios
        .get(url, { responseType: "blob" })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            oldThis.form.prisoner_full.string_details + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(function () {
          oldThis.snackbar_error = true;
        });
    }
  }
};
</script>